@if (alertaService.alertas().length > 0) {
<div class="alert-container">
  @for (alerta of alertaService.alertas(); track $index) {
  <article [ngClass]="alerta.type" class="alert fade-in" [attr.data-id]="alerta.id">
    <div class="alert-content">
      @if (alerta.type == 'warning') {
      <span class="icon">!</span>
      }
      @if (alerta.type == 'error') {
      <span class="icon">!</span>
      }
      @if (alerta.type == 'success') {
      <span class="icon">✔</span>
      }
      @if (alerta.type == 'info') {
      <app-icon [name]="'importante'" color="#036A70" size="1.5em"></app-icon>
      }

      <div class="alert-text">
        <strong>{{ alerta.title | translate }}</strong>
        <p [innerHTML]="alerta.message | translate"></p>
      </div>

      <button class="close-btn" (click)="alertaService.removeAlert(alerta.id)">
        &times;
      </button>
    </div>
  </article>
  }
</div>
}